import { computedFrom, autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { State } from '../../../services/global-state';
import { PayrazrService } from '../../../services/payrazr';
import { ValidationHelpers } from '../../../services/validation-helpers';
import { I18N } from 'aurelia-i18n';
import { PostLoginRouteManager } from '../../../helpers/post-login-route-manager';
@autoinject

export class SmsVerification {
	verificationCode: any;
	phoneNumber: any;
	redirectTo: any;
	customerId: string;

	constructor(private payrazrService: PayrazrService, private globalState: State, private router: Router, private i18n: I18N, private postLoginRouteManager: PostLoginRouteManager) {
		this.verificationCode = '';
	}

	@computedFrom('globalState.hasPayByTextEnabledPortfolio')
	get isPayByTextEnabled() {
		return this.globalState.hasPayByTextEnabledPortfolio;
	}

	@computedFrom('phoneNumber')
	get isCompletePhoneNumber() {
		if (!this.phoneNumber || this.phoneNumber.length < 10) {
			return false;
		}
		return true;
	}

	verify() {
		if (this.verificationCode) {
			let customerId = this.customerId;
			this.payrazrService.smsPhoneNumberVerification(this.verificationCode, customerId)
				.then(response => {
					if (response.isSuccessful) {
						alert(this.i18n.i18next.t('registrationForTextNotificationsSuccessful', 'You are now registered to receive text notifications.'));

						this.globalState.customer.notificationSettings.smsIsValidated = true;

						this.redirect();
					}
					else {
						if (response.message === 'errorEncounteredWhileValidatingVerificationCode') {
							response.message = this.i18n.i18next.t('errorEncounteredWhileValidatingVerificationCode', 'Error encountered while validating verification code.');
						}
						else if (response.message === 'invalidVerificationCode') {
							response.message = this.i18n.i18next.t('invalidVerificationCode', 'Invalid verification code.');
						}
						alert(response.message);
					}
				}).catch(error => {
					alert(this.i18n.i18next.t('errorWhileVerifyingCode', 'Error encountered while attempting to verify the code you entered.'));
				});
		}
		else {
			alert(this.i18n.i18next.t('enterVerificationCode', 'Please enter verification code.'));
		}
	}

	resendVerificationCode() {
		this.payrazrService.resendSmsVerificationCode(this.phoneNumber, this.customerId).then(response => {
			if (response.isSuccessful) {
				alert(this.i18n.i18next.t('verificationCodeResent', 'Verification code resent.'));
			}
			else {
				alert(this.i18n.i18next.t('failedToResendVerificationCode', 'Failed to resend verification code.'));
			}
		}).catch(error => {
			alert(this.i18n.i18next.t('errorWhileResendingVerificationCode', 'Error encountered when attempting to re-send verification code.'));
		});
	}

	cancel() {
		this.redirect();
	}

	private redirect() {
		let route = this.redirectTo || 'secure';

		if (route === 'dashboard'
			&& !this.router.hasRoute('dashboard')) {
			route = 'secure';
		}

		if (!this.redirectTo) {
			let routeResponse = this.postLoginRouteManager.calculateRoute();
			if (routeResponse.routeSettings) {
				this.router.currentInstruction.config.settings = routeResponse.routeSettings;
			}
			this.router.navigateToRoute(routeResponse.route);
		}
		else {
			this.router.navigateToRoute(route);
		}
	}

	activate() {
		let routeSettings = this.router.currentInstruction.config.settings;
		this.redirectTo = routeSettings.redirectTo;
		this.phoneNumber = ValidationHelpers.sanitizePhoneNumber(routeSettings.phoneNumber);
		this.customerId = routeSettings.customerId || null;
	}
}
